import { Utils } from 'mw-style-react';

// FORMS
export const GET_FORMS = Utils.createRequestTypes('GET_FORMS');
export const GET_SYSTEM_FORMS = Utils.createRequestTypes('GET_SYSTEM_FORMS');
export const GET_FORM = Utils.createRequestTypes('GET_FORM');
export const SEARCH_FORMS = Utils.createRequestTypes('SEARCH_FORMS');
export const REMOVE_FORM = Utils.createRequestTypes('REMOVE_FORM');
export const CREATE_FORM = Utils.createRequestTypes('CREATE_FORM');
export const UPDATE_FORM = Utils.createRequestTypes('UPDATE_FORM');
export const GET_FORM_ITEM_OPTIONS = Utils.createRequestTypes(
  'GET_FORM_ITEM_OPTIONS'
);
export const CLEAR_FORMS = 'CLEAR_FORMS';
export const CLEAR_FORM = 'CLEAR_FORM';
export const SET_FORMS_REQ_STATUS = 'SET_FORMS_REQ_STATUS';
export const SET_FORM_REQ_STATUS = 'SET_FORM_REQ_STATUS';

export const DEFAULT_FORM_TITLE = 'unnamedForm';

// FORMS ACCOUNTS
export const GET_FORM_ACCOUNTS = Utils.createRequestTypes('GET_FORM_ACCOUNTS');
export const MANAGE_FORM_ACCOUNTS = Utils.createRequestTypes(
  'MANAGE_FORM_ACCOUNTS'
);

export const DEFAULT_FORM_TEMPLATE = {
  title: 'Default Actor',
  sections: [
    {
      content: [
        {
          id: 'textField',
          class: 'edit',
          type: 'text',
          title: 'Title 1',
        },
      ],
    },
  ],
  settings: {},
  description: '',
};
